// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const chicken = defineModel({
  id: "chicken",
  batchId: "future",
  name: "Chicken",
  tags: ["creature","chicken","low-poly","age-of-mcp","future"],
  summary: "A chicken — eggs, meat and feathers around the farm.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.06,
  fits: ["draft"],
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.003, 0.003, 0.03, 4), color: "#e0a830", position: [0.004, 0.015, 0.015] },
      { geometry: new THREE.BoxGeometry(0.012, 0.003, 0.012), color: "#e0a830", position: [0.008, 0.001, 0.015] },
      { geometry: new THREE.CylinderGeometry(0.003, 0.003, 0.03, 4), color: "#e0a830", position: [0.004, 0.015, -0.015] },
      { geometry: new THREE.BoxGeometry(0.012, 0.003, 0.012), color: "#e0a830", position: [0.008, 0.001, -0.015] },
      { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#b06438", position: [0, 0.055, 0], scale: [1.25, 1.1, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.018, 0), color: "#cf8a56", position: [0.026, 0.05, 0], scale: [0.9, 1, 0.9] },
      { geometry: new THREE.IcosahedronGeometry(0.018, 0), color: "#b06438", position: [0.034, 0.078, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.006, 0), color: "#d63a2e", position: [0.034, 0.094, 0], scale: [1.5, 0.8, 0.6] },
      { geometry: new THREE.IcosahedronGeometry(0.005, 0), color: "#d63a2e", position: [0.043, 0.092, 0], scale: [1.2, 0.7, 0.6] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#d63a2e", position: [0.044, 0.07, 0] },
      { geometry: new THREE.ConeGeometry(0.006, 0.014, 4), color: "#f0b020", position: [0.05, 0.078, 0], rotation: [0, 0, -1.570796] },
      { geometry: new THREE.IcosahedronGeometry(0.003, 0), color: "#1a1010", position: [0.043, 0.082, 0.011] },
      { geometry: new THREE.IcosahedronGeometry(0.003, 0), color: "#1a1010", position: [0.043, 0.082, -0.011] },
      { geometry: new THREE.ConeGeometry(0.009, 0.04, 4), color: "#8a4a28", position: [-0.03, 0.072, 0], rotation: [0, 0, 1.8] },
      { geometry: new THREE.ConeGeometry(0.007, 0.034, 4), color: "#b06438", position: [-0.03, 0.072, 0.012], rotation: [0.4, 0, 1.9] },
      { geometry: new THREE.ConeGeometry(0.007, 0.034, 4), color: "#b06438", position: [-0.03, 0.072, -0.012], rotation: [-0.4, 0, 1.9] },
    ],
  animations: [],
});
